export { default as VideoChaptersMenu } from './component';
